<template>
  <section
    class="messages-section"
    :class="[
      isAdvancedFilter || isAdvancedFilterApplied ? 'advanced-filter' : 'simple-filter',
      isAdvancedFilter ? 'open' : '',
    ]"
  >
    <div class="top-bar" :style="{ flexDirection: isAdvancedFilterApplied && !isAdvancedFilter ? 'row-reverse' : ''}">
      <div
        class="settings-wrapper"
        :style="{
          justifyContent: isAdvancedFilterApplied? 'flex-end' : 'space-between',
          width: isAdvancedFilterApplied && !isAdvancedFilter ? 'auto' : '100%',
        }"
      >
        <CaseMessagesSearch
          v-if="!isAdvancedFilter && !isAdvancedFilterApplied"
          :active-chat-name="activeChatName"
          @search="handleSearch"
        />
        <div class="right-panel" :style="{ width: isAdvancedFilter ? '100%' : ''}">
          <div v-if="isAdvancedFilter" class="filter-types">
            <button
              :class="{selected: !filterTypeSaved}"
              class="filter-type"
              @click="filterTypeSaved = false"
            >
              Default
            </button>
            <button
              :class="{selected: filterTypeSaved}"
              class="filter-type"
              @click="filterTypeSaved = true"
            >
              Saved
            </button>
          </div>
          <button
            v-show="isAdvancedFilter"
            class="btn btn-revert device-configure"
            @click="$router.push({ name: 'Configure Device', query: { clientId } })"
          >
            Configure Device
          </button>
          <div class="advanced-change-button-wrapper">
            <button
              v-if="stringifiedRules"
              class="advanced-change-button add-to-favorites"
              @click="openSaveFilterPatternPopup"
            >
              <BlueBookmarkIcon1623 />
              <span>Add To Favorites</span>
            </button>
            <button
              v-if="isAdvancedFilterApplied || isAdvancedFilter"
              :disabled="!isAdvancedFilterApplied"
              class="reset-filters"
              @click="resetFilters"
            >
              <OrangeCloseIcon28 />
              Reset Filters
            </button>
            <button v-show="!searchText && !contactName" class="advanced-change-button" @click="changeFilterView">
              <BlueFilterIcon25 :class="{'advanced-mode': isAdvancedFilter}" />
              <span>Advanced</span>
              <GreyArrowDown17 :class="{'advanced-mode-arrow': isAdvancedFilter}" />
            </button>
          </div>
          <CaseMessagesNavigation v-show="!isAdvancedFilter && !isAdvancedFilterApplied && !searchText" />
        </div>
      </div>
      <div
        v-if="isLoad"
        v-show="isAdvancedFilter"
        class="advanced-filter-wrap"
        :style="{
          width: isAdvancedFilterApplied && !isAdvancedFilter ? 'auto' : '100%',
        }"
      >
        <SavedFilters
          v-if="filterTypeSaved"
          @attachFilter="attachFilter"
          @backToDefault="filterTypeSaved = false"
        />
        <div v-else class="control-section">
          <div class="col-lg-12 querybuilder-control">
            <ejs-querybuilder
              ref="querybuilder"
              :data-source="dataSource"
              :max-group-count="100"
              :rule="importRules"
              @change="ruleChanged"
            >
              <e-columns>
                <e-column
                  field="custodianEmail"
                  label="Search your custodian"
                  type="string"
                  :template="defaultTemplate"
                  :operators="[{ value: 'in', key: 'in' }, { value: 'not_in', key: 'not in' }]"
                />
                <e-column
                  field="message"
                  label="Search for a Phrase"
                  type="string"
                  :operators="[{ value: 'is', key: 'is' }, { value: 'is_not', key: 'is not' }, { value: 'contain', key: 'contain' }, { value: 'not_contain', key: 'not contain' }]"
                />
                <e-column
                  field="username"
                  label="Search the contact"
                  :template="defaultTemplate"
                  type="string"
                  :operators="[{ value: 'is', key: 'is' }, { value: 'is_not', key: 'is not' }, { value: 'in', key: 'in' }, { value: 'not_in', key: 'not in' }, { value: 'contain', key: 'contain' }, { value: 'not_contain', key: 'not contain' }]"
                />
                <e-column
                  field="imei"
                  label="Search for IMEI"
                  :template="defaultTemplate"
                  type="string"
                  :operators="[{ value: 'is', key: 'is' }, { value: 'is_not', key: 'is not' }, { value: 'in', key: 'in' }, { value: 'not_in', key: 'not in' }, { value: 'contain', key: 'contain' }, { value: 'not_contain', key: 'not contain' }]"
                />
                <e-column
                  field="phoneNumber"
                  label="Custodian phone number"
                  :template="defaultTemplate"
                  type="string"
                  :operators="[{ value: 'is', key: 'is' }, { value: 'is_not', key: 'is not' }, { value: 'in', key: 'in' }, { value: 'not_in', key: 'not in' }, { value: 'contain', key: 'contain' }, { value: 'not_contain', key: 'not contain' }]"
                />
                <e-column
                  field="dataType"
                  label="Data type"
                  type="string"
                  :template="defaultTemplate"
                  :operators="[{ value: 'in', key: 'in' }, { value: 'not_in', key: 'not in' }]"
                />
                <e-column
                  field="osSource"
                  label="OS source"
                  type="string"
                  :template="defaultTemplate"
                  :operators="[{ value: 'in', key: 'in' }, { value: 'not_in', key: 'not in' }]"
                />
                <e-column
                  field="messengerType"
                  label="Messenger"
                  type="string"
                  :template="defaultTemplate"
                  :operators="[{ value: 'in', key: 'in' }, { value: 'not_in', key: 'not in' }]"
                />
                <e-column
                  field="deviceOs"
                  label="Device OS"
                  type="string"
                  :template="defaultTemplate"
                  :operators="[{ value: 'is', key: 'is' }, { value: 'is_not', key: 'is not' }, { value: 'in', key: 'in' }, { value: 'not_in', key: 'not in' }]"
                />
                <e-column
                  field="deviceId"
                  label="Device Id"
                  :template="defaultTemplate"
                  type="string"
                  :operators="[{ value: 'is', key: 'is' }, { value: 'is_not', key: 'is not' }, { value: 'in', key: 'in' }, { value: 'not_in', key: 'not in' }, { value: 'contain', key: 'contain' }, { value: 'not_contain', key: 'not contain' }]"
                />
                <e-column
                  field="date"
                  label="Date"
                  type="date"
                  :template="dateTemplate"
                  :operators="[{ value: 'range', key: 'range' }]"
                  format="dd/MM/yyyy"
                />
              </e-columns>
            </ejs-querybuilder>
            <div class="advanced-btn-wrapper">
              <button class="btn btn-apply" type="button" @click="addRule">
                + Add Rule
              </button>
              <button class="btn btn-apply" type="button" @click="addGroup">
                + Add Group
              </button>
              <button
                :disabled="emptyRule"
                class="btn btn-apply"
                type="button"
                @click="filter(false)"
              >
                Apply
              </button>
              <span>{{ resultCount }} matches</span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="isAdvancedFilterApplied && !isAdvancedFilter" class="advanced-filter-wrap">
        <div class="filter-tags-close">
          <button class="advanced-change-button" @click="isOpenedFilterList = !isOpenedFilterList">
            <span>{{ isOpenedFilterList ? 'Close' : 'Show' }} Applied Filters</span>
            <GreyArrowDown17 :class="{'advanced-mode-arrow': isOpenedFilterList}" />
          </button>
        </div>

        <ul v-show="isOpenedFilterList" class="control-tags">
          <li
            v-for="tag of filteredTags"
            :key="tag.id"
            :class="{ 'removed': tag.removed }"
            class="filter-tag"
          >
            <button type="button" @click="removeFilter(tag)">
              <WhiteCloseIcon28 />
            </button>

            <strong>{{ tag.label | filteringLabel }}</strong>:&nbsp;
            <span>{{ tag.initialValue || tag.value }}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="filter-content">
      <div v-if="isViewWithSidebar" class="nav-chat">
        <div v-if="clientsArray.length" class="scroll-area">
          <MessagesList
            v-if="!searchText && !contactName"
            :clients-array="clientsArray"
            @setTabItemMsg="getTabItemMsg"
          />
          <SearchMessageList
            v-else
            :clients-array="searchableClientsArray"
            @setTabItemMsg="getTabItemMsg"
            @messageClicked="handleMessageClicked"
          />
        </div>
        <div v-else class="empty-chats-wrap">
          <span>No chats found</span>
        </div>
      </div>
      <div v-if="!isAdvancedFilterApplied" ref="messagesContainer" class="chat-list">
        <div class="messages">
          <div v-if="loadFlag" v-show="loaderPositioned" class="loader-bg">
            <div class="loader-p" />
          </div>
          <SetMessages
            v-if="tabItemMsg"
            ref="messagesList"
            :tab-item-msg="tabItemMsg"
            :messages="messages"
            :message-search="searchText"
            @changeCheckbox="changeMessageCheckbox"
            @downloadFile="downloadAttachment"
          />
          <infinite-loading
            v-if="currentUser"
            ref="scrollWrapper"
            :identifier="infiniteId"
            :direction="'top'"
            @infinite="infiniteHandler"
          >
            <div slot="spinner">
              Loading...
            </div>
            <div slot="no-more" />
            <div slot="no-results">
              No results
            </div>
          </infinite-loading>
          <div v-else class="no-messages-wrapper">
            <img :src="noMessagesImg" alt="">
            <span>Choose chat</span>
          </div>
          <SelectedMessagesInfo
            :messages="messages"
            :selected-messages-id="selectedMessagesId"
            :timer-started="timeRemaining"
            @updatedActiveStatus="updatedActiveStatus($event, 'messages')"
            @exportMessages="openExportPopup"
            @selectDB="format = $event"
          />
        </div>
      </div>
      <div v-else-if="!isAdvancedFilterApplied && !isViewWithSidebar" class="chat-list-group">
        <div v-if="loadFlag" v-show="loaderPositioned" class="loader-bg">
          <div class="loader-p" />
        </div>
        <SetGroupMessages
          :messages="messagesMerged"
          @changeCheckbox="changeMessageCheckbox"
          @downloadFile="downloadAttachment"
        />
        <infinite-loading
          ref="scrollWrapper2"
          direction="bottom"
          :identifier="infiniteMerged"
          @infinite="infiniteHandlerMerged"
        >
          <div slot="spinner">
            Loading...
          </div>
          <div slot="no-more">
            No more messages
          </div>
          <div slot="no-results">
            No results
          </div>
        </infinite-loading>
        <SelectedMessagesInfo
          :messages="messagesMerged"
          :selected-messages-id="selectedMessagesId"
          :timer-started="timeRemaining"
          @updatedActiveStatus="updatedActiveStatus($event, 'messagesMerged')"
          @exportMessages="openExportPopup"
          @selectDB="format = $event"
        />
      </div>
      <div v-else-if="isAdvancedFilterApplied" class="chat-list-group">
        <div v-if="loadFlag" v-show="loaderPositioned" class="loader-bg">
          <div class="loader-p" />
        </div>
        <SetAdvancedMessages
          v-if="tabItemMsg"
          :tab-item-msg="tabItemMsg"
          :messages="messagesAdvanced"
          @changeCheckbox="changeMessageCheckbox"
          @downloadFile="downloadAttachment"
        />
        <infinite-loading
          ref="scrollWrapper3"
          direction="bottom"
          :identifier="infiniteAdvancedId"
          @infinite="infiniteHandlerAdvanced"
        >
          <div slot="spinner">
            Loading...
          </div>
          <div slot="no-more">
            No more messages
          </div>
          <div slot="no-results">
            No results
          </div>
        </infinite-loading>
        <SelectedMessagesInfo
          :messages="messagesAdvanced"
          :selected-messages-id="selectedMessagesId"
          :timer-started="timeRemaining"
          @updatedActiveStatus="updatedActiveStatus($event, 'messagesAdvanced')"
          @exportMessages="openExportPopup"
          @selectDB="format = $event"
        />
      </div>
    </div>
    <CommonDialog
      ref="progressDialog"
      :show-footer="false"
      :closable="false"
    >
      <h2 class="dialog-message-title">
        Exporting messages
      </h2>
      <p class="dialog-create-description" style="display:block; font-size: 14px;">
        Please wait a bit. The messages are
        being exported.
      </p>
      <div class="loader-p" />
    </CommonDialog>
    <SuccessPopup
      ref="successPopup"
      text="A URL will be sent to your email with a download link. Do not share this link."
    />
    <CommonDialog ref="commonSuccessDialog" :show-footer="false">
      <SuccessIcon />
      <h2 class="dialog-message-title">
        Success!
      </h2>
      <p class="dialog-message-description" style="display:block;">
        Chosen messages were exported, you can find them on case export page. Would you like to see exported files?
      </p>
      <div class="dialog-btn-wrapper">
        <button
          id="dialoge_proceed"
          class="btn btn-export"
          @click="goToExportPage"
        >
          <span class="dialog-btn-text">Continue</span>
        </button>
        <button
          id="dialoge_close"
          class="btn btn-close btn-revert"
          @click="closeSuccessExportV2Popup"
        >
          <span class="dialog-btn-text">Close</span>
        </button>
      </div>
    </CommonDialog>
    <SaveFilterPattern
      ref="saveFilterPattern"
      @saveFilterPattern="saveFilterPattern"
    />
    <ExportPopup
      ref="exportPopup"
      :is-filters-applied="false"
      :is-messages-export="true"
      @export="exportMessages"
    />
  </section>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading';
import MessagesList from './MessageList';
import 'vue-custom-scrollbar/dist/vueScrollbar.css';
import SetMessages from './SetMessages';
import SetGroupMessages from './SetGroupMessages';
import settings from '../../../mixins/scrollSettings';
import Vue from 'vue';
import {
  ColumnDirective,
  ColumnsDirective,
  QueryBuilderComponent,
  QueryBuilderPlugin
} from '@syncfusion/ej2-vue-querybuilder';
import {DateRangePicker} from '@syncfusion/ej2-calendars';
import {AutoComplete, CheckBoxSelection, MultiSelect} from '@syncfusion/ej2-dropdowns';
import {createElement, getComponent} from '@syncfusion/ej2-base';
import {Query} from '@syncfusion/ej2-data';
import SelectedMessagesInfo from '@/components/selected-messages-info/SelectedMessagesInfo';
import SuccessPopup from '@/components/popups/SuccessPopup';
import SetAdvancedMessages from '@/components/cases/case-messages/SetAdvancedMessages';
import moment from 'moment';
import debounce from '@/mixins/debounce';
import SavedFilters from '@/components/cases/case-messages/SavedFilters';
import SaveFilterPattern from '@/components/popups/SaveFilterPattern';
import CommonDialog from '@/components/popups/CommonDialog.vue';
import capitalizeFirstLetter from '@/mixins/capitalizeFirstLetter';
import noMessagesImg from '@/assets/img/no-messages-img.png';
import CaseMessagesNavigation from '@/components/cases/case-messages/CaseMessagesNavigation.vue';
import CaseMessagesSearch from '@/components/cases/case-messages/CaseMessagesSearch.vue';
import {mapActions, mapGetters} from 'vuex';
import streamReader from '@/mixins/streamReader';
import ExportPopup from '@/components/popups/ExportPopup.vue';
import errorHandler from '@/mixins/errorHandler';
import exportTimer from '@/mixins/exportTimer';
import SuccessIcon from '@/components/icons/SuccessIcon.vue';
import BlueBookmarkIcon1623 from '@/components/icons/BlueBookmarkIcon1623.vue';
import OrangeCloseIcon28 from '@/components/icons/OrangeCloseIcon28.vue';
import BlueFilterIcon25 from '@/components/icons/BlueFilterIcon25.vue';
import GreyArrowDown17 from '@/components/icons/GreyArrowDown17.vue';
import WhiteCloseIcon28 from '@/components/icons/WhiteCloseIcon28.vue';
import SearchMessageList from '@/components/cases/case-messages/SearchMessageList.vue';

MultiSelect.Inject(CheckBoxSelection);

Vue.use(QueryBuilderPlugin);

let inOperators = ['is', 'is_not', 'contain', 'not_contain'];
const types = ['value', 'deleteRule', 'deleteGroup', 'condition'];

export default {
  name: 'CaseMessagesMobileChats',
  components: {
    SearchMessageList,
    WhiteCloseIcon28,
    GreyArrowDown17,
    BlueFilterIcon25,
    OrangeCloseIcon28,
    BlueBookmarkIcon1623,
    SuccessIcon,
    ExportPopup,
    CaseMessagesSearch,
    CaseMessagesNavigation,
    CommonDialog,
    SaveFilterPattern,
    SavedFilters,
    SetAdvancedMessages,
    SelectedMessagesInfo,
    InfiniteLoading,
    SetMessages,
    SetGroupMessages,
    SuccessPopup,
    MessagesList,
    'ejs-querybuilder': QueryBuilderComponent,
    'e-column': ColumnDirective,
    'e-columns': ColumnsDirective,
  },
  emits: ['show-error'],
  filters: {
    filteringLabel(label) {
      let labelsList = label.split(' ');
      labelsList = labelsList.map(phrase => {
        if (phrase === 'a' || phrase === 'for' || phrase === 'Search' || phrase === 'the') {
          return;
        }
        return phrase;
      });

      return labelsList.join(' ');
    }
  },
  mixins: [settings, debounce, capitalizeFirstLetter, streamReader, errorHandler, exportTimer],
  data() {
    return {
      noMessagesImg,
      filtersAppliedCount: 0,
      filtersAmountApplied: 0,
      isAdvancedFilterApplied: false,
      isLoad: true,
      dateRange: null,
      caseId: this.$route.params.slug,
      messengers: [],
      filterTypeSaved: false,
      searchInCurrentChat: false,
      contactName: false,
      searchText: '',
      sortBy: '',
      type: '',
      isAdvancedFilter: false,
      dateFrom: '',
      dateTo: '',
      clientId: '',
      clientsArray: [],
      searchableClientsArray: [],
      users: [],
      usersName: '',
      tabItemMsg: {},
      msgFilters: [],
      isOpenedFilterList: true,
      chatId: '',
      messages: [],
      messagesAdvanced: [],
      messagesMerged: [],
      selectedMessagesId: [],
      selectedMessagesIdCopy: [],
      format: 'pdf',
      filteredTags: [],
      isCheckedAllMessages: false,
      viewMessages: 'with-sidebar',
      withSidebar: 'with-sidebar',
      withoutSidebar: 'without-sidebar',
      infiniteId: +new Date(),
      infiniteAdvancedId: +new Date(),
      infiniteMerged: +new Date(),
      messagesChatPage: 1,
      MessagesChatSize: 20,
      MessagesMergedPage: 1,
      MessagesMergedSize: 20,
      MessagesAdvancedPage: 0,
      MessagesAdvancedSize: 20,
      advancedInfiniteHandlerState: null,
      currentUser: 0,
      currentMessengers: 'All',
      activeChatName: '',
      selectUser: false,
      dataSource: [],
      filterData: null,
      emptyRule: true,
      queryFilterParams: null,
      defaultQueryFilterParams: [],
      defaultImportRules: {
        'condition': 'and',
        'rules': [{}, {
          field: 'custodianEmail',
          operator: 'in',
          key: 'in',
          type: 'string',
          label: 'Search your custodian'
        }]
      },
      importRules: {
        'condition': 'and',
        'rules': [{}, {
          field: 'custodianEmail',
          operator: 'in',
          key: 'in',
          type: 'string',
          label: 'Search your custodian'
        }]
      },
      stringifiedRules: '',
      disabledFiltersId: [],
      resultCount: 0,
      clientList: [],
      groupCheckbox: false,
      loadFlag: true,
      scrollToActive: true,
      loaderPositioned: false,
      hasScrolledToTaggingMessage: false,
      initialData: [],
      dateTemplate: {
        create: () => {
          return createElement('input', {attrs: {'type': 'text'}});
        },
        destroy: (args) => {
          let daterangepicker = getComponent(document.getElementById(args.elementId), 'daterangepicker');
          if (daterangepicker)
            daterangepicker.destroy();
        },
        write: (args) => {
          let daterangepicker = new DateRangePicker({
            placeholder: 'Select date range',
            disabled: true,
            change: (e) => {
              this.$refs.querybuilder.$el.ej2_instances[0].notifyChange(e.value, e.element);
            },
          });

          if (args.values) {
            daterangepicker.startDate = new Date(this.formatDate(args.values[0]));
            daterangepicker.endDate = new Date(this.formatDate(args.values[1]));
          }

          daterangepicker.appendTo('#' + args.elements.id);
        }
      },

      defaultTemplate: {
        create: () => {
          return createElement('input', {attrs: {'type': 'text'}});
        },
        destroy: (args) => {
          let multiselect = getComponent(document.getElementById(args.elementId), 'multiselect');
          if (multiselect)
            multiselect.destroy();
          let autoComplete = getComponent(document.getElementById(args.elementId), 'autocomplete');
          if (autoComplete)
            autoComplete.destroy();
        },
        write: (args) => {
          let ds = [];

          if (args.field === 'custodianEmail') {
            ds = this.clientList;
          } else {
            this.initialData.forEach(item => {
              if (item.fieldName === args.field) {
                item.values.forEach(el => {
                  let elName = el[0].toUpperCase() + el.toLowerCase().slice(1);
                  ds.push({id: el, value: elName});
                });
              }
            });
          }

          if (inOperators.indexOf(args.operator) > -1) {
            let autoCompleteObj = new AutoComplete({
              dataSource: ds,
              fields: {text: 'value', value: 'id'},
              placeholder: `Find a ${this.stringModify(args.field)}`,
              highlight: true,
              itemTemplate: '<span class=\'filtering-name\'>${id}</span>',
              change: (e) => {
                const {field} = this.$refs.querybuilder.$el.ej2_instances[0].prevItemData;
                let name = '';

                if (e.itemData) {
                  name = e.itemData.id;
                }

                if (field === 'phoneNumber' || field === 'imei') {
                  name = name.replace(/[()]/g, '');
                }

                this.$refs.querybuilder.$el.ej2_instances[0].notifyChange(name, e.element);
              }
            });
            autoCompleteObj.appendTo('#' + args.elements.id);
          } else {
            let multiSelectObj = new MultiSelect({
              dataSource: ds,
              value: args.values,
              fields: {text: 'value', value: 'id'},
              mode: 'CheckBox',
              placeholder: `Select ${this.stringModify(args.field)}`,
              change: (e) => {
                this.$refs.querybuilder.$el.ej2_instances[0].notifyChange(e.value, e.element);
              },
              filtering: function (e) {
                let query = new Query();
                //frame the query based on search string with filter type.
                query = (e.text !== '') ? query.where('value', 'startswith', e.text, true) : query;
                //pass the filter data source, filter query to updateData method.
                e.updateData(ds, query);
              }
            });
            multiSelectObj.appendTo('#' + args.elements.id);
            if (args.values) {
              multiSelectObj.change(multiSelectObj);
            }
          }
        }
      },

      textTemplate: {
        create: () => {
          return createElement('input', {attrs: {'type': 'text'}});
        },
        destroy: (args) => {
          let autoComplete = getComponent(document.getElementById(args.elementId), 'autocomplete');
          autoComplete.destroy();
        },
        write: (args) => {
          let ds = [];

          this.initialData.forEach(item => {
            if (item.fieldName === this.$refs.querybuilder.$el.ej2_instances[0].prevItemData.field) {
              item.values.forEach(el => {
                ds.push({Name: el, Code: el});
              });
            }
          });

          let autoCompleteObj = new AutoComplete({
            dataSource: ds,
            fields: {value: 'Code', text: 'Name'},
            placeholder: `Find a ${this.$refs.querybuilder.$el.ej2_instances[0].prevItemData.field}`,
            highlight: true,
            itemTemplate: '<span class=\'filtering-name\'>${Name}</span>',
            change: (e) => {
              const {field} = this.$refs.querybuilder.$el.ej2_instances[0].prevItemData;
              let name = e.itemData.Name;

              if (field === 'phoneNumber' || field === 'imei') {
                name = name.replace(/[()]/g, '');
              }

              this.$refs.querybuilder.$el.ej2_instances[0].notifyChange(name, e.element);
            }
          });
          autoCompleteObj.appendTo('#' + args.elements.id);
        }
      },
    };
  },
  computed: {
    ...mapGetters('messagesTagging', {
      chatData: 'getChatData',
    }),
    isViewWithSidebar() {
      return this.viewMessages === this.withSidebar;
    },
    isValidQueryFilterParams() {
      return this.queryFilterParams.length === 1 && this.queryFilterParams[0] && !this.queryFilterParams[0].rules.length || this.queryFilterParams[0].rules[0] && !this.queryFilterParams[0].rules[0].value;
    },
  },
  watch: {
    // chatData: {
    //   handler(newVal, oldVal) {
    //     if (newVal && oldVal && newVal.taggingMessageId !== oldVal.taggingMessageId) {
    //       this.hasScrolledToTaggingMessage = false;
    //     }
    //   },
    //   deep: true
    // },
    viewMessages(val) {
      if (this.selectedMessagesId.length === 0) {
        this.isCheckedAllMessages = false;
        if (val === this.withSidebar) {
          this.messages.forEach(message => message.isActive = false);
        } else {
          this.messagesMerged.forEach(message => message.isActive = false);
        }
      }
    },
    // searchText() {
    //   if (!this.isViewWithSidebar) {
    //     this.messagesMerged = [];
    //     this.infiniteMerged += 1;
    //   }
    // },
    currentUser(value) {
      if (value) {
        if (value !== +this.$route.query.clientId) {
          this.$router.replace({query: {clientId: value}});
        }

        this.clientId = value;
        if (this.selectUser) {
          if (!this.isViewWithSidebar) {
            this.MessagesMergedPage = 1;
            this.messagesMerged = [];
            this.infiniteMerged += 1;
          } else {
            this.getCaseChats();
          }
        }

        this.getFilterRules();
        this.selectUser = true;
      }
    },
    currentMessengers(value) {
      if (value) {
        this.currentMessengers = value;
        if (!this.isViewWithSidebar) {
          this.MessagesMergedPage = 1;
          this.messagesMerged = [];
          this.infiniteMerged += 1;
        } else {
          this.getCaseChats();
        }
      }
    },
    dateRange(value) {
      if (value) {
        this.dateFrom = isNaN(Date.parse(value[0])) == false ? Date.parse(value[0]) : '';
        this.dateTo = isNaN(Date.parse(value[1])) == false ? Date.parse(value[1]) : '';
      }
    },
    loadFlag(value) {
      if (value) {
        this.$nextTick(() => {
          this.updateLoaderPosition();
        });
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateLoaderPosition);
    this.hasScrolledToTaggingMessage = false;
  },
  async mounted() {
    this.checkTimer('messagesExportEndTime');

    await this.setTaggingMode(false);

    window.addEventListener('resize', this.updateLoaderPosition);

    const observer = new MutationObserver(function (mutations) {
      mutations.forEach((mutation) => {
        if (
          mutation.type === 'childList'
          && mutation.addedNodes[0]
          && mutation.addedNodes[0].nodeType === Node.ELEMENT_NODE
        ) {
          if (mutation.addedNodes[0].querySelector('[style*="background-color: rgba(0, 0, 0, 0.5);"]')) {
            mutation.addedNodes[0].remove();
          }
        }
      });
    });

    document.querySelectorAll('a').forEach(element => {
      if (element.textContent.includes('Claim your free account')) {
        element.parentNode.remove();
      }
    });

    observer.observe(document.body, {childList: true});
    let el = document.querySelectorAll('*[id=\'js-licensing\']');
    if (el[0]) {
      el[0].remove();
    }

    const rulesFromServer = localStorage.getItem('rules');
    const clientId = this.$route.query.clientId;

    if (clientId) {
      this.clientId = clientId;
      this.currentUser = clientId;
      await this.getFilterRules();
    }

    await this.getUsersInMsg();
    this.getMessengers();

    if (rulesFromServer) {
      const parsedRules = JSON.parse(rulesFromServer);

      if (parsedRules.clientId === this.clientId) {
        this.setParsedRules(parsedRules);
      }
    }

    this.$nextTick(() => {
      this.updateLoaderPosition();
    });
  },
  methods: {
    ...mapActions('messagesTagging', {
      setTaggingMode: 'setTaggingMode',
      setChatData: 'setChatData',
      setSearchMessageId: 'setSearchMessageId',
    }),
    handleSearch(query, searchInCurrentChat = false, contactName = '', dateRange = null) {
      this.searchInCurrentChat = searchInCurrentChat;
      this.contactName = contactName;
      this.searchText = query;
      this.dateRange = dateRange;
      if (query || contactName) {
        this.debounce(() => this.getCaseChats(false), 100);
      } else {
        this.searchableClientsArray = [];
      }
    },
    closeSuccessExportV2Popup() {
      this.$refs.commonSuccessDialog.closePopups();
    },
    goToExportPage() {
      this.$router.push({path: `/cases/${this.caseId}/export`});
    },
    stringModify(str) {
      return str.split('').map((letter, idx) => {
        return letter.toUpperCase() === letter
          ? `${idx !== 0 ? ' ' : ''}${letter.toLowerCase()}`
          : letter;
      }).join('');
    },
    reset() {
      this.$refs.querybuilder.ej2Instances.reset();
      this.$refs.querybuilder.ej2Instances.levelColl = [];
    },
    addRule(_, rule) {
      let count = Object.keys(this.$refs.querybuilder.ej2Instances.levelColl)[Object.keys(this.$refs.querybuilder.ej2Instances.levelColl).length - 1].slice(-1);
      this.$refs.querybuilder.ej2Instances.addRules([rule || {field: 'custodianEmail'}], `group${count}`);
    },
    addGroup(_, group) {
      let count = Object.keys(this.$refs.querybuilder.ej2Instances.levelColl)[Object.keys(this.$refs.querybuilder.ej2Instances.levelColl).length - 1].slice(-1);
      this.$refs.querybuilder.ej2Instances.addGroups([group || {
        'condition': 'and',
        'rules': [{}, {field: 'custodianEmail'}]
      }], `group${count}`);

      document.querySelectorAll('.e-group-container').forEach(container => {
        const {classList} = container.previousSibling;

        if (classList && !classList.contains('last-rule-container')) {
          container.previousSibling.classList.add('last-rule-container');
        }
      });
    },
    updatedActiveStatus($event, messagesName) {
      this[messagesName] = $event.messages;
      this.isCheckedAllMessages = $event.isCheckedAllMessages;
      this.selectedMessagesId = $event.selectedMessagesId;
    },
    isCondition(item) {
      return item.condition !== undefined;
    },
    hasRuleset(condition) {
      return !!condition.rules && !!condition.rules.length;
    },
    formatDate(date) {
      const initial = date.split(/\//);

      return [initial[1], initial[0], initial[2]].join('/');
    },
    filterTags(rules) {
      rules.forEach(rule => {
        rule.rules ? this.filterTags(rule.rules) : this.filteredTags.push(rule);
      });
    },
    removeFilter(disabledTag) {
      let areThereRules = false;

      if (disabledTag.removed) {
        const disabledFilterId = this.disabledFiltersId.findIndex(el => el === disabledTag.id);

        this.disabledFiltersId.splice(disabledFilterId, 1);
      } else {
        this.disabledFiltersId.push(disabledTag.id);
      }

      disabledTag.removed = !disabledTag.removed;

      this.queryFilterParams = this.defaultQueryFilterParams
        .map(parameter => {
          const rules = parameter.rules.filter(rule => {
            for (let i = 0; i < this.disabledFiltersId.length; i++) {
              if (rule.id === this.disabledFiltersId[i]) {
                return false;
              }
            }

            return true;
          });

          if (rules.length) {
            areThereRules = true;
          }

          return {
            ...parameter,
            rules,
          };
        })
        .filter(queryParam => !!queryParam.rules.length);

      if (areThereRules) {
        this.messagesAdvanced = [];
        this.MessagesAdvancedPage = 0;

        this.debounce(() => {
          this.infiniteHandlerAdvanced(this.advancedInfiniteHandlerState);
        }, 1000);
      } else {
        this.resetFilters();
      }
    },

    flattenRules(rootRule) {
      if (!this.isCondition(rootRule) || !this.hasRuleset(rootRule)) return;

      const flat = (currentCondition) => {
        if (!this.hasRuleset(currentCondition)) return;

        // Filtering current ruleset to find inner conditions with non-empty rulesets;
        const nestedConditions = currentCondition.rules.filter(
          (item) => this.isCondition(item) && this.hasRuleset(item)
        );

        return [
          {
            ...currentCondition,
            // We exclude inner conditions from the ruleset and leave only the descriptions;
            rules: currentCondition.rules.filter((item) => !this.isCondition(item)),
          },
          ...nestedConditions.reduce(
            // We recursively call this function with all of the nested conditions;
            (acc, condition) => [...acc, ...flat(condition)],
            []
          ),
        ];
      };

      return flat(rootRule);
    },
    flatten(conditionsResult, setId) {
      let conditionsResultArray = this.flattenRules(conditionsResult);

      conditionsResultArray.forEach((item) => {
        if (item.condition === null) {
          item.condition = 'and';
        }
        if (item.rules.length) {
          item.rules.forEach((rule) => {
            if (setId) {
              rule.id = Math.random().toString(36).substr(2, 9);
            }
            if (rule.field !== 'date') {
              if (rule.field === 'custodianEmail') {
                rule.field = 'clientId';
              }

              if (Array.isArray(rule.value)) {
                rule.value = rule.value.join(';');
              }
            }
          });
        }
      });

      return conditionsResultArray;
    },
    changeFilterView() {
      this.isAdvancedFilter = !this.isAdvancedFilter;
    },
    filter(getResultCount) {
      if (!getResultCount) {
        this.stringifiedRules = JSON.stringify({
          clientId: this.clientId,
          rules: this.$refs.querybuilder.ej2Instances.rule.properties
        });

        localStorage.setItem('rules', this.stringifiedRules);
        this.queryFilterParams = this.getQueryParams(true);
      }

      this.filtersAmountApplied = this.queryFilterParams.reduce((a, b) => a + b.rules.length, 0);
      this.queryFilterParams = this.queryFilterParams.filter(param => param.rules.length);

      this.queryFilterParams.forEach(item => {
        if (item.rules.length) {
          item.rules.forEach((el, i) => {
            if (!el.value) {
              item.rules.splice(i, 1);
              return;
            }
            if (el.field === 'date') {

              if (el.value.length) {
                let dateObj = {
                  field: 'date',
                  label: 'Date',
                  operator: 'gth',
                  type: 'date',
                  value: ''
                };
                let dateFromObj = Object.assign({}, dateObj);
                let dateToObj = Object.assign({}, dateObj);
                let dateFrom = el.value[0].split('/');
                let dateTo = el.value[1].split('/');
                let dateFromTime = `${dateFrom[2]}-${dateFrom[1]}-${dateFrom[0]}`;
                let dateToTime = `${dateTo[2]}-${dateTo[1]}-${dateTo[0]}`;
                dateFrom = moment(dateFromTime).valueOf();
                dateTo = moment(dateToTime).endOf('day').valueOf();
                dateFromObj.value = dateFrom;
                dateFromObj.operator = 'gth';
                dateToObj.value = dateTo;
                dateToObj.operator = 'lth';
                dateFromObj.initialValue = dateFromTime;
                dateToObj.initialValue = dateToTime;
                item.rules.push(dateFromObj);
                item.rules.push(dateToObj);
                item.rules.splice(i, 1);
              }
            } else if (el.field === 'clientId') {
              let arr = el.value.split(';');
              arr.map((item, i) => {
                const client = this.clientList.find(client => client.id === item);

                if (client) {
                  arr[i] = client.value;
                }
              });
              el.initialValue = arr.join(';');
            }
          });
        }
      });

      this.filterData = JSON.stringify(this.msgFilters, null, 4);
      this.MessagesAdvancedPage = 0;

      if (this.advancedInfiniteHandlerState) {
        this.advancedInfiniteHandlerState.reset();
      }

      if (getResultCount) {
        this.getAdvancedResultAmount();
      } else {
        this.viewMessages = this.withoutSidebar;
        this.messagesAdvanced = [];
        this.filteredTags = [];
        this.isAdvancedFilterApplied = true;
        this.isAdvancedFilter = false;
        this.defaultQueryFilterParams = this.queryFilterParams;
        this.filterTags(this.queryFilterParams);
        this.debounce(() => this.infiniteAdvancedId += 1, 0);
      }
    },
    openSaveFilterPatternPopup() {
      this.$refs.saveFilterPattern.openPopups();
    },
    async saveFilterPattern(filterName) {
      await this.$load(async () => {
        try {
          await this.$api.cases.saveFilterPattern(this.caseId, {
            name: filterName,
            value: this.stringifiedRules,
          });
          this.stringifiedRules = '';
        } catch (error) {
          this.handleResponseError(error);
          this.$emit('show-error', error.response.data.errors.message.toString());
        }
      });
    },
    async attachFilter(filterId) {
      await this.$load(async () => {
        const filter = await this.$api.cases.getFilterPattern(this.caseId, filterId);
        this.filterTypeSaved = false;
        this.setParsedRules(JSON.parse(filter.data.body.value));
      });
    },
    resetFilters() {
      localStorage.removeItem('rules');
      this.stringifiedRules = '';
      this.isAdvancedFilter = true;
      this.isAdvancedFilterApplied = false;
      this.filtersAmountApplied = 0;
      this.messagesChatPage = 1;
      this.MessagesAdvancedPage = 0;
      this.queryFilterParams = null;
      this.messages = [];
      this.messagesAdvanced = [];
      this.viewMessages = this.withSidebar;
      this.groupCheckbox = false;
      this.filteredTags = [];
      this.isOpenedFilterList = true;
      this.resultCount = 0;
      this.reset();
      this.$refs.querybuilder.ej2Instances.setRules(this.defaultImportRules);
      this.filtersAppliedCount = 0;
      this.getUsersInMsg();
      this.getMessengers();
    },
    getQueryParams(setId = false) {
      this.msgFilters = this.$refs.querybuilder.ej2Instances.getValidRules(this.$refs.querybuilder.ej2Instances.rule);
      return this.flatten(this.msgFilters, setId);
    },
    setSavedRules(rules) {
      rules.forEach(rule => {
        if (rule.rules && rule.rules.length) {
          this.addGroup(false, {'condition': rule.condition || 'and', 'rules': [{}]});
          this.setSavedRules(rule.rules);
        } else if (rule.value) {
          this.addRule(false, rule);
        }
      });
    },
    changedQueryBuilder(e) {
      if (e.type === 'insertRule') {
        return;
      }

      this.queryFilterParams = this.getQueryParams();

      if (this.isValidQueryFilterParams) {
        this.resultCount = 0;
        return;
      }

      if (e.type === 'deleteGroup') {
        const groupID = e.groupID.split('group').join('');

        this.queryFilterParams.splice(groupID, 1);
      }

      if (types.some(type => type === e.type)) {
        this.filter(true);
      }
    },
    checkIsNestedRulesNotEmpty(rules) {
      return rules.every(rule => {
        if (rule.value === undefined) return true;

        return rule.rules
          ? this.checkIsNestedRulesNotEmpty(rule.rules)
          : rule.value && rule.value.length;
      });
    },
    ruleChanged(event) {
      const rules = [];

      this.$refs.querybuilder.ej2Instances.rule.properties.rules.forEach(rule => {
        if (rule.rules) {
          if (!rule.rules.length) {
            return;
          }

          rules.push(this.checkIsNestedRulesNotEmpty(rule.rules));
          return;
        }

        rules.push(rule.value && !!rule.value.length);
      });

      this.emptyRule = rules.some(rule => rule !== undefined && !rule);

      if (!this.emptyRule || (!this.emptyRule && event.type === 'condition')) {
        this.debounce(this.changedQueryBuilder, 1000, event);
      }
    },
    changeCheckbox() {
      this.viewMessages = this.isViewWithSidebar ? this.withoutSidebar : this.withSidebar;
    },
    changeMessageCheckbox(item) {
      if (item.isActive) {
        this.selectedMessagesId.push(item.id);
      } else {
        this.selectedMessagesId = this.selectedMessagesId.filter(id => id !== item.id);
      }
    },
    downloadAttachment(attachment) {
      this.$load(async () => {
        await this.$api.cases
          .downloadAttachment(this.caseId, attachment.id)
          .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', attachment.name);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
          }, (error) => {
            this.handleResponseError(error);
            if (error.response) {
              this.$emit('show-error', error.response.data.errors.message[0]);
            } else {
              this.$emit('show-error', error.data.errors.message[0]);
            }
          });
      });
    },
    getTabItemMsg(data) {
      if (this.tabItemMsg && this.tabItemMsg.chatId !== data.chatId) {
        this.messagesChatPage = 1;
        this.messages = [];
        this.tabItemMsg = data;
        this.chatId = data.chatId;
        this.activeChatName = this.tabItemMsg.chatName;
        this.infiniteId += 1;
      }
    },

    // users in select
    async getUsersInMsg() {
      await this.$load(async () => {
        await this.$api.cases.getUsersInMessages({
          caseId: this.caseId,
        }).then((res) => {
          this.clientList = [];
          if (res.data.body.length > 0) {
            this.users = res.data.body;
            this.users.forEach((item) => {
              this.clientList.push({id: String(item.id), value: item.name});
            });

            const currentUser = this.users.find(user => user.id === this.currentUser);

            if (currentUser) {
              this.usersName = currentUser.name;
            } else {
              this.currentUser = this.users[0].id;
              this.usersName = this.users[0].name;
            }

            // this.getCaseChats(this.currentUser);
          } else {
            this.loadFlag = false;
          }
          this.isLoad = true;
        }, (error) => {
          this.handleResponseError(error);
          if (error.response) {
            this.$emit('show-error', error.response.data.errors.message[0]);
          } else {
            this.$emit('show-error', error.data.errors.message[0]);
          }
        });
        setTimeout(() => {
          // this.loadFlagPermission = false
        }, 1000);
      });
    },

    // viber.... in select
    getMessengers() {
      this.$load(async () => {
        // this.loadFlagPermission = true
        await this.$api.cases.getMessengersInMessages(this.caseId, this.currentUser).then((res) => {
          this.messengers = res.data.body.types.map(i => {
            return {
              name: i
            };
          });
        }, (error) => {
          this.handleResponseError(error);
          if (error.response) {
            this.$emit('show-error', error.response.data.errors.message[0]);
          } else {
            this.$emit('show-error', error.data.errors.message[0]);
          }
        });
        setTimeout(() => {
          // this.loadFlagPermission = false
        }, 1000);
      });
    },

    fixedEncodeURIComponent(str) {
      return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
        return '%' + c.charCodeAt(0).toString(16);
      });
    },

    async getMessageById() {
      await this.$load(async () => {
        await this.$api.messagesTagging.getMessageById(this.caseId, this.chatId, this.chatData.taggingMessageId);
      }, (error) => {
        this.handleResponseError(error);
        this.loadFlag = false;
        throw null;
      });
    },

    setCurrentClientData(currentClient, updateChat) {
      if (this.chatData.chatId) {
        this.handleExistingChatId(currentClient, updateChat);
      } else {
        this.setDefaultChat(currentClient);
      }
    },

    handleExistingChatId(currentClient, updateChat) {
      const messagesArray = this.extractAllMessages(currentClient);
      this.tabItemMsg = messagesArray.find(message => message.chatId === this.chatData.chatId);

      if (!this.tabItemMsg) {
        this.setDefaultChat(currentClient);
      } else {
        this.setupExistingChat(updateChat);
      }
    },

    extractAllMessages(currentClient) {
      const messagesArray = [];
      currentClient.chatRooms
        .map(chatRoom => chatRoom.lastMessageChatInfo)
        .forEach(lastMessage => {
          messagesArray.push(...lastMessage);
        });
      return messagesArray;
    },

    setDefaultChat(currentClient) {
      const currentChat = currentClient.chatRooms[0];
      this.tabItemMsg = currentChat.lastMessageChatInfo[0];
      this.chatId = currentChat.lastMessageChatInfo[0].chatId;
      this.loadFlag = false;
    },

    setupExistingChat(updateChat) {
      this.activeChatName = this.tabItemMsg.chatName;
      this.chatId = this.chatData.chatId;

      if (this.shouldScrollToTaggedMessage(updateChat)) {
        this.scheduleScrollToMessage();
      } else {
        this.loadFlag = false;
      }
    },

    shouldScrollToTaggedMessage(updateChat) {
      return this.chatData.taggingMessageId && !this.searchText && updateChat;
    },

    scheduleScrollToMessage() {
      const SCROLL_DELAY_MS = 1000;
      setTimeout(async () => {
        try {
          await this.getMessageById();
          this.scrollToMessage();
        } catch (error) {
          // ignore
        }
      }, SCROLL_DELAY_MS);
    },

    // left list
    getCaseChats(updateChat = true) {
      this.$load(async () => {
        const res = await this.$api.cases.getCaseChats({
          caseId: this.caseId,
          chatId: this.searchInCurrentChat ? this.chatId : '',
          contactName: this.contactName || '',
          // clientId: this.searchInCurrentChat ? this.chatData.clientId : '',
          clientId: '',
          keySearch: this.fixedEncodeURIComponent(this.searchText),
          dateFrom: this.dateFrom,
          dateTo: this.dateTo,
        });
        if (this.searchText || this.contactName) {
          this.searchableClientsArray = res.data.body;
        } else {
          this.clientsArray = res.data.body;
        }

        const resultsArray = this.searchText || this.contactName ? this.searchableClientsArray : this.clientsArray;
        if (resultsArray.length > 0 && !this.searchText && !this.contactName) {
          if (this.chatData
            && (Number(this.chatData.caseId) === Number(this.caseId))
            && this.chatData.clientId) {
            const currentClient = resultsArray.find(client => client.clientId === this.chatData.clientId);
            this.setCurrentClientData(currentClient, updateChat);
          } else {
            const nonEmptyClient = resultsArray.find(client => client.chatRooms.length > 0);
            this.tabItemMsg = nonEmptyClient.chatRooms[0].lastMessageChatInfo[0];
            this.chatId = nonEmptyClient.chatRooms[0].lastMessageChatInfo[0].chatId;
            this.loadFlag = false;
          }
        } else {
          this.loadFlag = false;
        }

        if ((!this.searchText && !this.contactName) && updateChat) {
          this.messagesChatPage = 1;
          this.messages = [];
          this.infiniteId += 1;
        }
      }, (error) => {
        this.handleResponseError(error);
      });
    },
    infiniteHandler($state) {
      this.debounce(() => {
        if (this.chatId) {
          this.$load(async () => {
            const res = await this.$api.cases.getMessagesChat({
              caseId: this.caseId,
              chatId: this.chatId,
              page: this.messagesChatPage,
              size: this.MessagesChatSize
            });
            if (res.data.body.content.length) {
              if (this.isCheckedAllMessages) {
                res.data.body.content.forEach(message => {
                  this.selectedMessagesId.push(message.id);
                  message.isActive = true;
                });
              }
              const newMessages = res.data.body.content;
              const existingMessageIds = new Set(this.messages.map(msg => msg.id));
              const uniqueNewMessages = newMessages.filter(msg => !existingMessageIds.has(msg.id)).reverse();
              this.messages.unshift(...uniqueNewMessages);
              $state.loaded();
            }
            if (res.data.body.last) {
              $state.complete();
            }
            if (!this.scrollToActive) {
              this.loadFlag = false;
            }
            this.messagesChatPage += 1;
          }, (error) => {
            this.handleResponseError(error);
            if (error.response) {
              this.$emit('show-error', error.response.data.errors.message[0]);
            } else {
              this.$emit('show-error', error.data.errors.message[0]);
            }
            if (!this.scrollToActive) {
              this.loadFlag = false;
            }
            $state.error();
          });
        } else {
          $state.complete();
          if (!this.scrollToActive) {
            this.loadFlag = false;
          }
        }
      }, 300);
    },
    getAdvancedResultAmount() {
      if (this.queryFilterParams.length) {
        this.$load(() => {
          this.$api.cases.sendAdvancedFilterParams(this.caseId, this.queryFilterParams, 1, this.MessagesAdvancedSize, true)
            .then(res => {
              this.resultCount = res.data.body.totalElements;
            });
        });
      }
    },
    infiniteHandlerAdvanced($state) {
      if (this.queryFilterParams) {
        this.$load(() => {
          this.MessagesAdvancedPage += 1;
          this.$api.cases.sendAdvancedFilterParams(this.caseId, this.queryFilterParams, this.MessagesAdvancedPage, this.MessagesAdvancedSize, false).then((res) => {
            if (res.data.body.content.length) {
              const newMessages = res.data.body.content.reverse();

              if (this.isCheckedAllMessages) {
                newMessages.forEach(message => {
                  this.selectedMessagesId.push(message.id);
                  message.isActive = true;
                });
              }

              this.messagesAdvanced.unshift(...newMessages);
              if ($state) {
                // this.infiniteAdvancedId += 1;
                this.advancedInfiniteHandlerState = $state;
                $state.loaded();
              }
            } else {
              if ($state) {
                $state.complete();
              }
            }
          }, (error) => {
            this.handleResponseError(error);
            if (error.response) {
              this.$emit('show-error', error.response.data.errors.message[0]);
            } else {
              this.$emit('show-error', error.data.errors.message[0]);
            }
          });
        });
      }
    },
    infiniteHandlerMerged($state) {
      this.$load(async () => {
        await this.$api.cases.getMessagesMerged({
          caseId: this.caseId,
          clientId: this.clientId,
          messengers: this.currentMessengers,
          dateFrom: this.dateFrom,
          dateTo: this.dateTo,
          page: this.MessagesMergedPage,
          size: this.MessagesMergedSize
        }).then((res) => {

          if (res.data.body.content.length) {
            this.MessagesMergedPage += 1;
            const newMessages = res.data.body.content.reverse();

            if (this.isCheckedAllMessages) {
              newMessages.forEach(message => {
                this.selectedMessagesId.push(message.id);
                message.isActive = true;
              });
            }

            this.messagesMerged.unshift(...newMessages);
            $state.loaded();
          } else {
            $state.complete();
          }
        }, (error) => {
          this.handleResponseError(error);
          if (error.response) {
            this.$emit('show-error', error.response.data.errors.message[0]);
          } else {
            this.$emit('show-error', error.data.errors.message[0]);
          }
          $state.error();
        });
      });
    },
    openExportPopup(format = null, data) {
      this.format = format;
      this.selectedMessagesIdCopy = data;
      this.$refs.exportPopup.openPopups();
    },
    // eslint-disable-next-line no-unused-vars
    exportMessages(format, config, applyTimeframes) {
      if (format === 'rsmf' || format === 'csv') {
        this.exportV1(format);
      } else if (format === 'pdf' || format === 'xml') {
        this.exportV2(format, config, applyTimeframes);
      }
      this.$refs.exportPopup.closePopups();
    },
    exportV1(format) {
      this.$load(async () => {
        this.$refs.progressDialog.openPopups();
        const response = await this.$api.cases.exportMessagesV1(
          this.caseId,
          format,
          {messageIds: this.selectedMessagesIdCopy}
        );
        this.startExportTimer('messagesExportEndTime');
        // eslint-disable-next-line no-undef
        const reader = response.body.pipeThrough(new TextDecoderStream()).getReader();
        await this.processStreamData(reader, 33);
        this.handleStreamResult();

        this.resetCheckboxes();
      }, (error) => {
        this.handleResponseError(error);
        if (error.response) {
          this.$emit('show-error', error.response.data.errors.message[0]);
        } else {
          this.$emit('show-error', error.data.errors.message[0]);
        }
      });
    },
    exportV2(format, config, applyTimeframes) {
      this.$load(async () => {
        this.$refs.progressDialog.openPopups();
        const response = await this.$api.cases.exportMessagesV2(
          this.caseId,
          format,
          applyTimeframes,
          {
            config: config,
            messages: {messageIds: this.selectedMessagesIdCopy},
          });
        this.startExportTimer('messagesExportEndTime');
        // eslint-disable-next-line no-undef
        const reader = response.body.pipeThrough(new TextDecoderStream()).getReader();
        await this.processStreamData(reader, 33);
        this.handleStreamResult(false);

        this.resetCheckboxes();

        this.$refs.commonSuccessDialog.openPopups();
      }, (error) => {
        this.handleResponseError(error);
        if (error.response) {
          this.$emit('show-error', error.response.data.errors.message[0]);
        } else {
          this.$emit('show-error', error.data.errors.message[0]);
        }
      });
    },

    getFilterRules() {
      this.isLoad = false;
      this.debounce(() => {
        this.$load(async () => {
          await this.$api.cases.getFilterRules(this.caseId, this.clientId).then((res) => {
            this.initialData = res.data.body;
            this.isLoad = true;
          });
        });
      }, 10);
    },

    setParsedRules(parsedRules) {
      this.importRules = {};
      this.viewMessages = this.withoutSidebar;
      this.isAdvancedFilterApplied = true;

      setTimeout(() => {
        const {rules} = parsedRules.rules;
        const lastRuleRules = rules[rules.length - 1].rules;

        this.setSavedRules(!lastRuleRules || lastRuleRules && lastRuleRules.length ? rules : rules.reverse());
        this.queryFilterParams = this.getQueryParams(true);

        this.filter(true);
        this.filter();
      }, 1000);
    },
    resetCheckboxes() {
      this.selectedMessagesId = [];

      this.isCheckedAllMessages = false;

      if (this.viewMessages === this.withSidebar) {
        this.messages = this.messages.map(message => ({...message, isActive: false}));
      } else if (this.isAdvancedFilterApplied) {
        this.messagesAdvanced = this.messagesAdvanced.map(message => ({...message, isActive: false}));
      } else {
        this.messagesMerged = this.messagesMerged.map(message => ({...message, isActive: false}));
      }
    },
    handleMessageClicked(data) {
      const messageId = data.messageId;
      const chatId = data.chatId;
      const isSameChat = data.isSameChat;

      if (isSameChat) {
        this.scrollToMessage(messageId);
        return;
      }

      this.loadFlag = true;
      this.updateLoaderPosition();
      this.scrollToActive = true;

      if (!messageId) return;

      if (chatId && chatId !== this.chatId) {
        this.messagesChatPage = 1;
        this.messages = [];
        this.chatId = chatId;
        this.infiniteId += 1;

        this.setSearchMessageId(messageId);

        setTimeout(() => {
          this.scrollToMessage(messageId);
        }, 1000);
      } else {
        this.scrollToMessage(messageId);
      }
    },
    scrollToMessage(messageId = null) {
      this.$nextTick(() => {
        try {
          const targetMessageId = messageId || this.chatData.taggingMessageId;

          if (!targetMessageId) {
            console.warn('No message ID provided for scrolling');
            return;
          }

          // Prevent duplicate scrolling to tagging message
          if (!messageId && this.chatData.taggingMessageId && this.hasScrolledToTaggingMessage) {
            this.loadFlag = false;
            this.scrollToActive = false;
            return;
          }

          const messageRef = this.$refs.messagesList.getMessageRef(targetMessageId);
          if (messageRef) {
            messageRef.scrollIntoView({
              behavior: 'smooth',
              block: 'center',
              inline: 'nearest',
            });

            // Only set search message ID if we have a specific messageId (for search functionality)
            if (messageId) {
              this.setSearchMessageId(targetMessageId);
            }

            this.loadFlag = false;
            this.scrollToActive = false;

            // Mark that we've scrolled to the tagging message to prevent duplicates
            if (!messageId && this.chatData.taggingMessageId) {
              this.hasScrolledToTaggingMessage = true;
            }
          } else {
            this.scrollToTop();
            setTimeout(() => this.scrollToMessage(messageId), 1000);
          }
        } catch (e) {
          console.error('Error scrolling to message:', e);
          setTimeout(() => this.scrollToMessage(messageId), 1000);
        }
      });
    },
    scrollToTop() {
      this.$refs.messagesContainer.scrollTop = 0;
    },
    updateLoaderPosition() {
      let container;
      if (this.isAdvancedFilterApplied) {
        container = this.$el.querySelector('.chat-list-group');
      } else if (!this.isViewWithSidebar) {
        container = this.$el.querySelector('.chat-list-group');
      } else {
        container = this.$refs.messagesContainer;
      }

      if (!container) return;

      const loaderBgs = this.$el.querySelectorAll('.loader-bg');
      if (!loaderBgs.length) return;

      const rect = container.getBoundingClientRect();

      loaderBgs.forEach(loaderBg => {
        loaderBg.style.position = 'fixed';
        loaderBg.style.top = `${rect.top}px`;
        loaderBg.style.left = `${rect.left}px`;
        loaderBg.style.width = `${rect.width}px`;
        loaderBg.style.height = `${rect.height}px`;
      });
      this.loaderPositioned = true;
    },
  },
};
</script>

<style scoped>

.messages-section {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  margin: 27px 55px 27px 35px;
}

.filter-content {
  display: flex;
  width: 100%;
  max-height: 76vh;
}

.nav-chat {
  margin-top: 92px;
  max-width: 385px;
  width: 100%;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #D7DCE6;
}

.nav-chat .scroll-area {
  height: fit-content;
}

.advanced-filter .nav-chat {
  margin-top: 0;
}

.advanced-filter .chat-list {
  margin-top: 30px;
}

.simple-filter .top-bar {
  padding: 30px 24px;
}

.chat-list {
  width: 100%;
  height: 100%;
  max-height: 90vh;
  overflow: visible;
  margin-top: 120px;
  display: flex;
  overflow-y: auto;
  scrollbar-color: var(--background-color) transparent;
  scrollbar-width: thin;
  position: relative;
}

.chat-list .messages {
  position: relative;
  width: 100%;
  height: 100%;
}

.chat-list .loader-bg,
.chat-list-group .loader-bg {
  /* Position and dimensions will be set by script */
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  pointer-events: all;
  min-height: 80vh;
}

.top-bar {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  padding: 28px 22px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  background: #FFFFFF;
  box-shadow: 0 4px 10px rgba(77, 106, 147, 0.15);
}

.advanced-filter .top-bar {
  position: static;
  width: 100%;
}

.open.advanced-filter .top-bar {
  padding-bottom: 35px;
}

.advanced-change-button-wrapper {
  display: flex;
}

.settings-wrapper {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.messages-section.open .settings-wrapper {
  padding-bottom: 28px;
  border-bottom: 0.5px solid var(--case-filters-border-color);
}

.filter-types {
  display: flex;
  align-items: center;
  border-radius: 79px;
  outline: 1px solid var(--case-btn-border-color);
  width: fit-content;
  min-height: 35px;
}

.filter-type {
  height: 35px;
  position: relative;
  z-index: 2;
  transition: outline 0.3s, color 0.3s;
  border: none;
  border-radius: 79px;
  outline: 1px solid transparent;
  width: 144px;
  padding: 5px 16px;
  background-color: transparent;
  font-size: 14px;
  font-weight: 600;
  line-height: 14px;
  color: var(--light-gray);
}

.filter-type.selected {
  outline: 1px solid var(--accent-color);
  color: var(--accent-color);
}

.filter-type:hover {
  color: var(--accent-color);
}

.reset-filters {
  background-color: transparent;
  display: flex;
  align-items: center;
  border: none;
  margin-right: 23px;
  padding: 0;
  font-weight: 500;
  font-size: 14px;
  color: var(--secondary-black-color);
}

.reset-filters:disabled path {
  fill: var(--case-btn-border-color);
}

.reset-filters:disabled {
  cursor: not-allowed;
}

.reset-filters svg {
  margin-right: 10px;
}

.reset-filters:not(:disabled):hover {
  text-decoration: underline;
}

.add-to-favorites {
  margin-right: 23px;
}

.advanced-change-button {
  height: 30px;
  display: flex;
  align-items: center;
  border: none;
  outline: none;
  padding: 0;
  background-color: unset;
}

.advanced-change-button span {
  margin: 0 6px;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: #373C44;
}

.advanced-change-button:hover span {
  text-decoration: underline;
}

.advanced-mode {
  fill: var(--accent-color);
}

.advanced-mode-arrow {
  transform: rotate(180deg);
}

/* end top bar */

/* for view group */
.chat-list-group {
  position: relative;
  width: 100%;
  max-height: 64.3vh;
  overflow: auto;
  margin-top: 30px;
}

.empty-chats-wrap {
  margin: 50% auto;
  font-size: 14px;
  font-weight: 500;
  line-height: 17px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: var(--light-gray);
}

label {
  display: block;
  margin-bottom: 5px;
}

.advanced-filter-wrap {
  position: relative;
}

.e-query-builder {
  width: 100% !important;
}

.control-tags {
  margin-bottom: 0;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.filter-tag {
  display: flex;
  align-items: center;
  width: max-content;
  padding: 6px 12px;
  border-radius: 20px;
  background-color: var(--accent-color);
  font-size: 13px;
  color: var(--white-color);
}

.filter-tag button {
  display: flex;
  margin-right: 8px;
  border: navajowhite;
  padding: 0;
  background-color: unset;
}

.filter-tag.removed path {
  fill: #ff9537;
}

.filter-tag svg {
  width: 18px;
  height: 18px;
}

.filter-tag path {
  transition: fill 0.3s;
}

.filter-tag strong {
  text-transform: capitalize;
}

.filter-tags-close {
  display: flex;
  align-items: center;
}

.filter-tags-arrow {
  transition: all 0.3s;
}

.filtering-name b {
  color: red;
}

.device-configure {
  padding: 9px 20px;
  max-height: 35px;
}


.dialog-message-title {
  font-style: normal;
  font-weight: bold;
  font-size: 30px;
  line-height: 36px;
  color: #292B2F;
  text-align: center;
  margin: 25px 0 0;
  display: block;
  width: 100%;
}

.dialog-create-description {
  font-size: 14px;
  font-weight: 500;
  line-height: 17px;
  text-align: center;
  color: var(--light-gray);
  margin: 10px 0 0;
}

.loader-p {
  width: 50px;
  height: 50px;
  position: relative;
  margin: 20px 40px 20px 0;
}

.no-messages-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 150px auto;
  max-width: 350px;
  width: 100%;
  gap: 40px;
}

.no-messages-wrapper span {
  font-size: 16px;
  font-weight: 500;
  line-height: 25.6px;
  text-align: center;
  color: var(--light-gray);
}

.dialog-message-title {
  font-style: normal;
  font-weight: bold;
  font-size: 30px;
  line-height: 36px;
  color: #292B2F;
  text-align: center;
  margin: 0;
  display: block;
  width: 100%;
  margin-top: 25px;
}

.dialog-message-description {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 26px;
  text-align: center;
  color: #696F79;
  display: block;
  margin-top: 20px;
  padding: 0 30px;
}

.dialog-btn-wrapper {
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  gap: 20px;
}

.dialog-btn-wrapper .btn {
  height: 48px;
}

.dialog-btn-wrapper .btn-export {
  background-color: var(--accent-color);
  border: 1px solid var(--accent-color);
}

.dialog-btn-wrapper .btn-close:hover {
  background-color: var(--white-color);
}

.dialog-btn-wrapper .btn-export .dialog-btn-text {
  color: var(--white-color);
}

.dialog-btn-wrapper .btn-export:hover {
  color: var(--white-color);
}

.dialog-btn-wrapper .btn-export:hover {
  background-color: var(--accent-color);
  color: var(--white-color);
  border: 1px solid var(--accent-color);
}

.loader-bg {
  position: fixed;
  top: 0;
  left: 0;
  transform: none;
  transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
  opacity: 1;
  visibility: visible;
}

[v-show="false"].loader-bg {
  opacity: 0;
  visibility: hidden;
}

.right-panel {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
}
</style>
